"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
var Role;
(function (Role) {
    Role["User"] = "user";
    Role["CommunityTournamentCreator"] = "communityTournamentCreator";
    Role["ExternalDistributor"] = "externalDistributor";
    Role["GameAdministrator"] = "gameAdministrator";
    Role["TournamentAdministrator"] = "tournamentAdministrator";
    Role["TournamentSponsoredCreator"] = "tournamentSponsoredCreator";
    Role["MatchAdministrator"] = "matchAdministrator";
    Role["TournamentCreator"] = "tournamentCreator";
    Role["UserAdministrator"] = "userAdministrator";
    Role["UserWalletAdministrator"] = "userWalletAdministrator";
    Role["PaymentAdministrator"] = "paymentAdministrator";
    Role["RampWidgetUser"] = "rampWidgetUser";
    Role["AffiliateProgramAdmin"] = "affiliate_program_admin";
    Role["AffiliateProgramOwner"] = "affiliate_program_owner";
})(Role = exports.Role || (exports.Role = {}));
//# sourceMappingURL=role.js.map